import StatisticsClub from "components/statistics/StatisticsClub";
import Statistics from "components/statistics/Statistics";
import { AiOutlinePlus } from "react-icons/ai";
import { useState } from "react";
import { FaFilter, FaTrashAlt } from "react-icons/fa";
import Club from "./Club";
import Score from "./Score";
import styles from "./cusclub.scss";
import l1 from "assets/images/l1 (4).svg";
import l3 from "assets/images/l1 (2).svg";
import l2 from "assets/images/l1 (3).svg";
import l4 from "assets/images/l1 (1).svg";
function CustomerClub() {
  const [editDisable, setEditDisable] = useState([{ status: true }]);
  const editHandler = () => {
    setEditDisable((prevState) => {
      return [...prevState, (editDisable[0].status = !editDisable[0].status)];
    });
  };
  return (
    <div className="stySac container">
      {/* <StatisticsClub /> */}
      <div className="d-flex flex-wrap">
        <div className="col-md-3 col-6">
          <Statistics
            title=" تعداد امتیاز داده شده"
            type={1}
            txt="تامین کننده"
            number={145}
            icon={l1}
          />
        </div>
        <div className="col-md-3 col-6">
          <Statistics
            title="تعداد امتیاز مصرف شده"
            type={2}
            txt="تامین کنند فعال"
            number={145}
            icon={l2}
          />
        </div>
        <div className="col-md-3 col-6">
          <Statistics
            title="بیشترین امتیاز کاربر"
            type={3}
            txt="سوپرمارکت"
            number={145}
            icon={l3}
          />
        </div>
        <div className="col-md-3 col-6">
          <Statistics
            title="کمترین امتیاز کاربر"
            type={4}
            txt="پروتئینی"
            number={145}
            icon={l4}
          />
        </div>
        <div className="col-md-3 col-6">
          <Statistics
            title="تعداد امتیاز داده شده"
            type={4}
            txt="پروتئینی"
            number={145}
            icon={l4}
          />
        </div>
      </div>
      <div>
        <ul
          class="nav nav-tabs  align-items-center"
          style={{ borderBottom: "2px solid #2C4E83" }}
        >
          <li class="nav-item mx-2" role="presentation">
            <button
              class="nav-link active"
              id="home-tab"
              data-bs-toggle="tab"
              data-bs-target="#home"
              type="button"
              role="tab"
              aria-controls="home"
              aria-selected="true"
              onClick={editHandler}
            >
              باشگاه مشتریان سوپر ادمین
            </button>
          </li>

          <li class="nav-item">
            <button
              class="nav-link "
              id="contact-tab"
              data-bs-toggle="tab"
              data-bs-target="#contact"
              type="button"
              role="tab"
              aria-controls="contact"
              aria-selected="true"
              onClick={editHandler}
            >
              امتیاز ها
            </button>
          </li>
          <div className="ms-auto">
            {editDisable[0].status ? (
              <button
                className={`btn  mx-1 my-3 btnHov`}
                id=""
                data-bs-toggle="modal"
                data-bs-target="#exampleModalAdd"
              >
                <div className="d-flex justify-content-around align-items-center text-center">
                  <AiOutlinePlus />
                  <p
                    className="textPro"
                    style={{ marginBottom: "0px", marginRight: "3px" }}
                  >
                    {" "}
                    افزودن تنظیمات
                  </p>
                </div>
              </button>
            ) : (
              <>
                <button
                  className="btn  mx-1 my-3 btnHov"
                  id=""
                  style={{ background: "#CCEEF0", border: "#5EAAB7 1px solid" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalLabelScore"
                >
                  <div className="d-flex justify-content-around align-items-center text-center ">
                    <AiOutlinePlus />
                    <p
                      className="textPro"
                      style={{ marginBottom: "0px", marginRight: "3px" }}
                    >
                      {" "}
                      افزودن امتیاز
                    </p>
                  </div>
                </button>
                <button className="btn btn-danger mx-1 my-3" id="">
                  <div className="d-flex justify-content-around align-items-center text-center">
                    <FaTrashAlt />
                    <p
                      className="textPro"
                      style={{ marginBottom: "0px", marginRight: "3px" }}
                    >
                      {" "}
                      حذف فیلتر
                    </p>
                  </div>
                </button>
                <button
                  className="btn text-white  mx-1 my-3 hov2"
                  id=""
                  style={{ background: "#1A3764" }}
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModalLabeFilter"
                >
                  <div className="d-flex justify-content-around align-items-center text-center">
                    <FaFilter />
                    <p
                      className="textPro"
                      style={{ marginBottom: "0px", marginRight: "3px" }}
                    >
                      {" "}
                      فیلتر
                    </p>
                  </div>
                </button>
              </>
            )}
          </div>
        </ul>
      </div>
      <div class="tab-content w-100" id="myTabContent">
        <div
          class="tab-pane fade show active"
          id="home"
          role="tabpanel"
          aria-labelledby="home-tab"
        >
          <div className=" w-100 mt-2 ">
            <div className="container">
              <Club />
            </div>
          </div>
        </div>

        <div
          class="tab-pane fade"
          id="contact"
          role="tabpanel"
          aria-labelledby="contact-tab"
        >
          <div className=" w-100 mt-3 ">
            <div className="container">
              <Score />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerClub;
